import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getDevicesWithoutPagination } from 'app/entities/device/device.reducer';
import SelectPaginate from 'app/shared/components/select-paginate/SelectPaginate';
import { IDeviceTruckImplement } from 'app/shared/model/device-truck-implement.model';
import { IDevice } from 'app/shared/model/device.model';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { toast } from 'react-toastify';
import { createEntity, getEntity, reset, updateEntity } from './device-truck-implement.reducer';

export const DeviceTruckImplementUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const [truckImplement, setTruckImplement] = useState<ITruckImplement>(null);
  const [device, setDevice] = useState<IDevice>(null);
  const [deviceTruckImplement, setDeviceTruckImplement] = useState<IDeviceTruckImplement | any>(null);

  const devices = useAppSelector(state => state.device.entities);
  const deviceTruckImplementEntity = useAppSelector(state => state.deviceTruckImplement.entity);
  const loading = useAppSelector(state => state.deviceTruckImplement.loading);
  const updating = useAppSelector(state => state.deviceTruckImplement.updating);
  const updateSuccess = useAppSelector(state => state.deviceTruckImplement.updateSuccess);

  const handleClose = () => {
    props.history.push('/device-truck-implement' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getDevicesWithoutPagination());
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...deviceTruckImplementEntity,
      ...values,
      device,
      truckImplement,
    };

    if (!entity?.device?.id) {
      return toast.error('Necessário selecionar um equipamento');
    }

    if (!entity?.truckImplement?.id) {
      return toast.error(<Translate contentKey="fleetSenseApp.deviceTruckImplement.missingAsset" />);
    }

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  useEffect(() => {
    deviceTruckImplementEntity &&
      setDeviceTruckImplement({
        ...deviceTruckImplementEntity,
        deviceId: deviceTruckImplementEntity?.device?.id,
        truckImplementId: deviceTruckImplementEntity?.truckImplement?.id,
      });
  }, [deviceTruckImplementEntity]);

  useEffect(() => {
    if (deviceTruckImplementEntity?.truckImplement && !isNew) {
      setTruckImplement(deviceTruckImplementEntity?.truckImplement);
      setDevice(deviceTruckImplementEntity?.device);
    }
  }, [deviceTruckImplementEntity]);

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.deviceTruckImplement.home.createOrEditLabel" data-cy="DeviceTruckImplementCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.deviceTruckImplement.home.createOrEditLabel">Create or edit a DeviceTruckImplement</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={deviceTruckImplement} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="device-truck-implement-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                  className="d-none"
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.deviceTruckImplement.serial')}
                id="device-truck-implement-serial"
                name="serial"
                required
                data-cy="serial"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.deviceTruckImplement.firmware')}
                id="device-truck-implement-firmware"
                name="firmware"
                data-cy="firmware"
                type="text"
              />
              <div className="mb-3">
                <label data-tip data-for="truckImplementTip">
                  {translate('fleetSenseApp.deviceTruckImplement.device')}
                </label>
                <SelectPaginate apiUrl="api/devices" onChange={setDevice} value={device} placeholder="" valueName="model" isRequired />
              </div>
              <div className="mb-3">
                <label data-tip data-for="truckImplementTip">
                  {translate('fleetSenseApp.deviceTruckImplement.truckImplement')}
                </label>
                <SelectPaginate
                  apiUrl="api/truck-implements"
                  onChange={setTruckImplement}
                  value={truckImplement}
                  placeholder=""
                  valueName="licensePlate"
                  searchName="plateSearch"
                  isRequired
                />
              </div>
              <ValidatedField
                label={translate('fleetSenseApp.deviceTruckImplement.imei')}
                id="device-truck-implement-imei"
                name="imei"
                data-cy="imei"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.deviceTruckImplement.iccid')}
                id="device-truck-implement-iccid"
                name="iccid"
                data-cy="iccid"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/device-truck-implement" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DeviceTruckImplementUpdate;
